import React from "react";
import { Route, Switch } from "react-router";
import HomeContainer from "../container/HomeContainer";
import ImpressumContainer from "../container/ImpressumContainer";
import KontaktContainer from "../container/KontaktContainer";
import LeistungenContainer from "../container/LeistungenContainer";
import UeberUnsContainer from "../container/UeberUnsContainer";
import FooterContainer from "../container/FooterContainer";
import HeaderContainer from "../container/HeaderContainer";
import { GERMAN } from "../actions/language";
import { LanguageContext } from "../context/LanguageContext";
import { connect } from "react-redux";
import DataProtectionContainer from "../container/DataProtectionContainer";
import AgbContainer from "../container/AgbContainer";
import {PlatformContext} from "../context/PlatformContext";
import {MAINTENANCE} from "../env";
import {DESKTOP} from "../actions/mobile";
import PlatformService from "../functional/PlatformService";
import Cookies from "./Cookies";
import OfficeServiceContainer from "../container/OfficeServiceContainer";
import AssistanceContainer from "../container/AssistanceContainer";
import AdministrationContainer from "../container/AdministrationContainer";
import ScrollToTop from "./common/ScrollToTop";

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: window.localStorage.getItem('language') || GERMAN,
            platform: window.localStorage.getItem('platform') || DESKTOP,
        };
        this.setLanguage = this.setLanguage.bind(this);
        this.setPlatform = this.setPlatform.bind(this);
    }

    // Method to update language
    setLanguage(newLanguage) {
        this.setState({ language: newLanguage });
        window.localStorage.setItem('language', newLanguage);
    }

    setPlatform(newPlatform) {
        this.setState({ platform: newPlatform });
        window.localStorage.setItem('platform', newPlatform);
    }

    render() {
        const { language, platform } = this.state;

        return (
            <PlatformContext.Provider value={{ platform , setPlatform: this.setPlatform}}>
                <LanguageContext.Provider value={{ language, setLanguage: this.setLanguage }}>
                    <div id="page">
                        <PlatformService />
                        {
                            MAINTENANCE === false ?
                                <div>
                                    <ScrollToTop/>
                                    <HeaderContainer />
                                    <div id="general-background-color">
                                        <Switch>
                                            <Route path="/about-us/" component={UeberUnsContainer}/>
                                            <Route path="/services/" component={LeistungenContainer}/>
                                            <Route path="/office-service/" component={OfficeServiceContainer}/>
                                            <Route path="/assistance/" component={AssistanceContainer}/>
                                            <Route path="/administration/" component={AdministrationContainer}/>
                                            <Route path="/contact/" component={KontaktContainer}/>
                                            <Route path="/impressum/" render={() => (
                                                <div className="tm-legacy-offset"><ImpressumContainer/></div>
                                            )}/>
                                            <Route path="/data-protection" render={() => (
                                                <div className="tm-legacy-offset"><DataProtectionContainer/></div>
                                            )}/>
                                            <Route path="/agb" render={() => (
                                                <div className="tm-legacy-offset"><AgbContainer/></div>
                                            )}/>
                                            <Route path="/" component={HomeContainer}/>
                                        </Switch>
                                    </div>
                                    <Cookies/>
                                    <FooterContainer/>
                                </div> :
                                <div>
                                    {
                                        platform === DESKTOP ?
                                            <center>
                                                <img
                                                    src="/img/maintenance-page.png"
                                                    alt="Wartungsarbeiten"
                                                    style={{height: "280px", width: "480px"}}
                                                />
                                            </center> : <center className="pt-4">
                                                <img
                                                    src="/img/maintenance-page.png"
                                                    alt="Wartungsarbeiten"
                                                    style={{height: "180px", width: "340px"}}
                                                />
                                            </center>
                                    }
                                </div>
                        }
                    </div>
                </LanguageContext.Provider>
            </PlatformContext.Provider>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js